import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import MicroModal from 'micromodal';
import {params} from './parts/vars/params';
import {elms} from './parts/vars/elms';
import {resize} from './parts/utils/resize';
import {ham} from './parts/components/common/ham';
import {marquee} from './parts/components/common/marquee';
import {para} from './parts/components/common/para';
import {scrollIn} from './parts/components/common/scrollIn';
import {tabs} from './parts/components/common/tabs';
import {accordion} from './parts/components/common/accordion';
import {numRoller} from './parts/components/common/num-roller';
import {copyright} from './parts/components/common/copyright';
import {guidelines} from './parts/components/top/guidelines';
import {scrollTo} from './parts/components/common/scrollTo';
import {news} from './parts/components/top/news';
import {slider} from './parts/components/ip/slider';
import {initThreeResults} from './parts/components/results/results';
// import {twoDigits, addComma, inArray} from './lib/utils';
// {twoDigits, addComma, inArray}

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /iphone|ipod|ipad|android/.test(userAgent);
const bodyClass = isMobile ? 'mobile' : 'pc';
document.body.classList.add(bodyClass);

gsap.registerPlugin(ScrollTrigger);

let initialized: boolean = false;

setTimeout(() => {
  if (!initialized) {
    init();
    initialized = true;
  }
}, 3000);

window.addEventListener('load', () => {
  if (!initialized) {
    init();
    initialized = true;
  }
  params.loadingComplete = true;
});

window.addEventListener('unhandledrejection', function (event) {
  if (event.reason === null) {
    // Ignore null rejections
    return;
  }
  // console.log('UNHANDLED PROMISE REJECTION:', event.reason);
});

const init = (): void => {
  if (elms.ham) ham();
  if (elms.guidelines) guidelines();
  scrollTo();
  marquee();
  para();
  scrollIn();
  tabs();
  accordion();
  numRoller();
  copyright();
  news();
  if (elms.ipLeadSlider) slider();
  if (elms.results) initThreeResults(elms.results.querySelector('.p-projects-mv__canvas') as HTMLElement);
  MicroModal.init();

  ScrollTrigger.config({
    // default is "resize,visibilitychange,DOMContentLoaded,load" so we can remove "resize" from the list:
    autoRefreshEvents: 'DOMContentLoaded',
    ignoreMobileResize: true,
  });
  ScrollTrigger.refresh();
  resize();
};
